import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {IDialogData} from "../../index";
import * as ko from "knockout";
import {nsModal} from "./fn";

export let template: string = dialogHtml;

import formatTitle = nsModal.formatTitle;
import dialogHtml from './dialog.html?raw';

export class viewModel {

    dialogData: KnockoutObservable<IDialogData | null>;
    showModal = ko.observable(false);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    constructor(params: any) {
        this.dialogData = params.dialogData;
        this.showModal(!!this.dialogData());

        this.kosub.subscribe(this.dialogData, (data: IDialogData | null) => {
            this.showModal(!!data);
        });

        this.kosub.subscribe(this.showModal, (bool: boolean) => {
            if (!bool) {
                jQuery('.modal-backdrop').remove();
            }
        });

        window.addEventListener("popstate", this.windowPopStateListener, true);

    }

    windowPopStateListener = (e: PopStateEvent) => {
        this.dialogData(null);
    };

    onCloseClick = () => {
        const data = this.dialogData();
        data?.onClose?.();
        this.dialogData(null);
    };

    onConfirmClick = () => {
        const data = this.dialogData();
        data?.onConfirm?.();
        this.dialogData(null);
    };

    onCancelClick = () => {
        const data = this.dialogData();
        data?.onCancel?.();
        this.dialogData(null);
    };

    isFooter = ko.pureComputed(() => {
        const data = this.dialogData();
        return !!(data?.onConfirm || data?.onCancel);
    });

    private getTitle() {
        const data = this.dialogData();
        return data ? formatTitle(data.title) : '';
    }

    dispose() {
        window.removeEventListener("popstate", this.windowPopStateListener, true);
    }

}
